import FadeInSection from '@/components/base/FadeInSection';

const features = [
  {
    icon: 'ri-leaf-line',
    title: 'Fresh Quality',
    description: 'Carefully selected fruits and vegetables with focus on freshness and quality. Every batch is inspected before dispatch.',
  },
  {
    icon: 'ri-truck-line',
    title: 'Reliable Supply',
    description: 'Consistent supply solutions for business requirements. We ensure timely availability of produce throughout the year.',
  },
  {
    icon: 'ri-shopping-basket-2-line',
    title: 'Bulk Orders',
    description: 'Suitable for restaurants, retailers, distributors, supermarkets and quick-commerce supply chains with flexible quantities.',
  },
  {
    icon: 'ri-group-line',
    title: 'Trusted Partnership',
    description: 'Professional service focused on long-term business relationships built on trust, transparency, and mutual growth.',
  },
];

export default function WhyChooseUs() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
        <FadeInSection>
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-800 text-xs font-semibold rounded-full mb-4">
            Why Partner With Us
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Why Choose <strong className="text-primary-600">Bassi Enterprises</strong>
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            We deliver more than just produce — we deliver reliability, quality, and a partnership you can count on.
          </p>
        </div>
        </FadeInSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature, idx) => (
            <FadeInSection key={feature.title} delay={idx * 100}>
            <div
              className="group relative bg-background-50 border border-background-200 rounded-xl p-6 md:p-7 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              {/* Icon */}
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-50 flex items-center justify-center mb-4 md:mb-5 transition-colors duration-300 group-hover:bg-primary-100">
                <i className={`${feature.icon} text-primary-600 text-xl md:text-2xl`}></i>
              </div>

              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 mb-2">
                {feature.title}
              </h3>

              <p className="text-foreground-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
            </FadeInSection>
          ))}
        </div>
        </div>
    </section>
  );
}